import React from "react";

const HowItWorks = () => {

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-2236ed5 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="2236ed5" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;,&quot;background_background&quot;:&quot;classic&quot;}" style={{ width: '100%', left: '0px' }}>
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0769641" data-id="0769641" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-7f8ad4b elementor-widget elementor-widget-dc_element_working_process" data-id="7f8ad4b" data-element_type="widget" data-widget_type="dc_element_working_process.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-how-it-work dc-haslayout dynamic-secton-795896">
                                    <div className="dc-haslayout dc-workholder">
                                        <div className="container">
                                            <div className="row justify-content-center align-self-center">
                                                <div className="col-xs-12 col-sm-12 col-md-8 push-md-2 col-lg-8 push-lg-2">
                                                    <div className="dc-sectionhead dc-text-center">
                                                        <div className="dc-sectiontitle">
                                                            <h2>
                                                                <span>We Made It Simple</span>													How It <em>Works?</em>												</h2>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Effortlessly connect with top professionals, schedule appointments, and provide feedback, all in a few simple steps.</p>											</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dc-haslayout dc-workdetails-holder">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                    <div className="dc-workdetails ">
                                                        <div className="dc-workdetail">
                                                            <figure>
                                                                <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2024/11/img-01-3.png" alt="Search Best Online" />
                                                            </figure>
                                                        </div>
                                                        <div className="dc-title">
                                                            <span>Search Best Online</span>
                                                            <h3>Professional</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                    <div className="dc-workdetails dc-workdetails-border">
                                                        <div className="dc-workdetail">
                                                            <figure>
                                                                <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2024/11/img-02-4.png" alt="Get Instant" />
                                                            </figure>
                                                        </div>
                                                        <div className="dc-title">
                                                            <span>Get Instant</span>
                                                            <h3>Appointment</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                    <div className="dc-workdetails dc-workdetails-bordertwo">
                                                        <div className="dc-workdetail">
                                                            <figure>
                                                                <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2024/11/img-03-3.png" alt="Leave Your" />
                                                            </figure>
                                                        </div>
                                                        <div className="dc-title">
                                                            <span>Leave Your</span>
                                                            <h3>Feedback</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
